var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAndroidTvIconCmu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_849_207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.9829 21.3359H18.0176C15.3394 21.3359 13.1689 23.5133 13.1689 26.1846V50.1707C13.1689 52.849 15.3463 55.0194 18.0176 55.0194H30.3029V56.9185H21.5237C20.6333 56.9185 19.9029 57.6212 19.9029 58.4838C19.9029 59.3464 20.6263 60.049 21.5237 60.049H58.3794C59.2698 60.049 60.0003 59.3464 60.0003 58.4838C60.0003 57.6212 59.2768 56.9185 58.3794 56.9185H49.6976V55.0194H61.9829C64.6611 55.0194 66.8316 52.842 66.8316 50.1707V26.1916C66.8316 23.5133 64.6542 21.3429 61.9829 21.3429V21.3359ZM63.3533 50.1777C63.3533 50.9359 62.7342 51.5481 61.9829 51.5481H18.0176C17.2594 51.5481 16.6472 50.929 16.6472 50.1777V26.1916C16.6472 25.4333 17.2663 24.8212 18.0176 24.8212H61.9898C62.7481 24.8212 63.3603 25.4403 63.3603 26.1916V50.1777H63.3533Z",
    fill: "url(#paint0_linear_849_207)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8696 80H19.1304C8.58435 80 0 71.4157 0 60.8696V19.1304C0 8.58435 8.58435 0 19.1304 0H60.8696C71.4157 0 80 8.58435 80 19.1304V60.8696C80 71.4157 71.4157 80 60.8696 80ZM19.1304 3.47826C10.4974 3.47826 3.47826 10.4974 3.47826 19.1304V60.8696C3.47826 69.5026 10.4974 76.5217 19.1304 76.5217H60.8696C69.5026 76.5217 76.5217 69.5026 76.5217 60.8696V19.1304C76.5217 10.4974 69.5026 3.47826 60.8696 3.47826H19.1304Z",
    fill: "url(#paint1_linear_849_207)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_849_207",
    x: 0,
    y: 0,
    width: 80,
    height: 84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_849_207"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_849_207",
    x1: 40.0002,
    y1: 21.3359,
    x2: 40.0002,
    y2: 60.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E12426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#C61F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41214"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_849_207",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E12426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#C61F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41214"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidTvIconCmu);
export default __webpack_public_path__ + "static/media/android_tv_icon_cmu.b9f1f547bede7d1aaadd2ce41219f1be.svg";
export { ForwardRef as ReactComponent };